import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.technicalVisitPage || initialState;

export const technicalVisitPageSelector = createSelector(
  [selectDomain],
  (technicalVisitPageState) => technicalVisitPageState,
);
